export const NOT_ELIGIBLE_FOR_INTERVIEW = "NOT_ELIGIBLE_FOR_INTERVIEW";
export const ELIGIBLE_FOR_INTERVIEW = "ELIGIBLE_FOR_INTERVIEW";
export const CANDIDATE_MATCHING = "CANDIDATE_MATCHING";
export const CANDIDATE_BEST_MATCHING = "CANDIDATE_BEST_MATCHING";
export const CANDIDATE_CLOSE_TO_MATCH = "CANDIDATE_CLOSE_TO_MATCH";
export const REJECTED = "REJECTED";